import { render, staticRenderFns } from "./personalsummary.vue?vue&type=template&id=43ba5dcc&scoped=true"
import script from "./personalsummary.vue?vue&type=script&lang=js"
export * from "./personalsummary.vue?vue&type=script&lang=js"
import style0 from "./personalsummary.vue?vue&type=style&index=0&id=43ba5dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ba5dcc",
  null
  
)

export default component.exports